import React from 'react';
import PropTypes from 'prop-types';
import FolderOpen from '@material-ui/icons/FolderOpen';

const container = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#fff',
};

const icon = {
  fontSize: '3em',
  color: '#ddd',
};

const msg = {
  color: '#ddd',
};

const Empty = ({ message, ...rest }) => {
  return (
    <div style={{ ...container, ...rest }}>
      <FolderOpen style={icon} />
      {message && <div style={msg}>{message}</div>}
    </div>
  );
};

Empty.propTypes = {
  message: PropTypes.string,
};

export default Empty;
